/**
 * @file 学びメモ本文の画像参照 (`note-image:<id>`) の扱い。
 *
 * @what: 本文には `![](note-image:<id>)` の形で画像を差し込む。表示のときだけ blob URL に
 *   置き換え、保存する本文には blob URL を書かない。
 * @why: Storage の URL (期限つき) を本文に書くと、期限切れで本文が壊れる。id 参照なら
 *   本文・images メタ・Storage の実体が 1 つの id で結ばれ、AI がメモを読むときも
 *   本文中の参照位置と画像の実体を突き合わせられる (CLI note-images)。
 * @failure: 純関数。解決先が無い参照はそのまま残す (プレビューで壊れ画像として見え、
 *   書いた人が気づける)。
 */

/** 本文中の画像参照。id はノートの images の id と一致する。 */
const NOTE_IMAGE_REF = /note-image:([a-z0-9-]{1,64})/g;

/** 本文が参照している画像 id の集合。 */
export function referencedNoteImageIds(body: string): Set<string> {
  const ids = new Set<string>();
  for (const m of body.matchAll(NOTE_IMAGE_REF)) {
    ids.add(m[1]!);
  }
  return ids;
}

/** 表示用に、参照を blob URL へ置き換えた本文を返す (未取得の参照はそのまま)。 */
export function resolveNoteImageUrls(body: string, urls: ReadonlyMap<string, string>): string {
  return body.replace(NOTE_IMAGE_REF, (whole, id: string) => urls.get(id) ?? whole);
}

/** 本文から画像の参照 (`![](note-image:<id>)`) を落とした文を返す。 */
export function stripNoteImageRefs(text: string): string {
  return text.replace(/!\[[^\]]*\]\(note-image:[a-z0-9-]{1,64}\)/g, "");
}

/** 挿入する Markdown 断片 (前後に空行を置いて、段落として差し込む)。 */
export function noteImageSnippet(id: string): string {
  return `\n\n![](note-image:${id})\n\n`;
}
